const HomeSidebarSkeleton = () => {
    return (
        <div className="mt-4 p-2">
            <div>
                <div className="skeleton-placeholder width25 height3"></div>
            </div>

            {[...Array(2)].map((_, i) => {
                return (
                    <div className="mt-2">
                        <div className="skeleton-placeholder width25 height2"></div>
                    </div>
                );
            })}

            <div className="mt-4">
                <div className="skeleton-placeholder width25 height3"></div>
            </div>

            {[...Array(4)].map((_, i) => {
                return (
                    <div className="mt-2">
                        <div className="skeleton-placeholder width25 height2"></div>
                    </div>
                );
            })}
        </div>
    );
}

export default HomeSidebarSkeleton;
